import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import { Pagination as UikitPagination } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';

import styles from './styles.module.scss';
import type { Component } from './types';

export const Pagination: Component = ({
  totalPage,
  value,
  onPageChange,
}) => {
  const { isDesktop } = useScreenDetect();
  const isDesktopMode = isDesktop();

  if (isDesktopMode) {
    return (
      <UikitPagination
        siblingCount={2}
        totalPage={totalPage}
        value={value}
        onPageChange={onPageChange} />
    );
  }

  return (
    <UikitPagination
      menuClassName={cx(
        styles.menuRoot,
        styles.isShortenMenu,
      )}
      totalPage={totalPage}
      value={value}
      isMobile
      onPageChange={onPageChange} />
  );
};
